import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import upgradesEn from './locales/en/upgrades.json';
import commonEn from './locales/en/common.json';
import statisticsEn from './locales/en/statistics.json';
import generatorsEn from './locales/en/generators.json';
import settingsEn from './locales/en/settings.json';
import menusEn from './locales/en/menus.json';
import tooltipEn from './locales/en/tooltip.json';
import infosEn from './locales/en/infos.json';
import gameEn from './locales/en/game.json';
import dungeonEn from './locales/en/dungeon.json';

import upgradesFr from './locales/fr/upgrades.json';
import commonFr from './locales/fr/common.json';
import statisticsFr from './locales/fr/statistics.json';
import generatorsFr from './locales/fr/generators.json';
import settingsFr from './locales/fr/settings.json';
import menusFr from './locales/fr/menus.json';
import tooltipFr from './locales/fr/tooltip.json';
import infosFr from './locales/fr/infos.json';
import gameFr from './locales/fr/game.json';
import dungeonFr from './locales/fr/dungeon.json';

import upgradesPt from './locales/pt/upgrades.json';
import commonPt from './locales/pt/common.json';
import statisticsPt from './locales/pt/statistics.json';
import generatorsPt from './locales/pt/generators.json';
import settingsPt from './locales/pt/settings.json';
import menusPt from './locales/pt/menus.json';
import tooltipPt from './locales/pt/tooltip.json';
import infosPt from './locales/pt/infos.json';
import gamePt from './locales/pt/game.json';
import dungeonPt from './locales/pt/dungeon.json';

import upgradesDe from './locales/de/upgrades.json';
import commonDe from './locales/de/common.json';
import statisticsDe from './locales/de/statistics.json';
import generatorsDe from './locales/de/generators.json';
import settingsDe from './locales/de/settings.json';
import menusDe from './locales/de/menus.json';
import tooltipDe from './locales/de/tooltip.json';
import infosDe from './locales/de/infos.json';
import gameDe from './locales/de/game.json';
import dungeonDe from './locales/de/dungeon.json';

import intervalPlural from 'i18next-intervalplural-postprocessor';

intervalPlural.setOptions({
  // these are the defaults
  intervalSeparator: ';',
  intervalRegex: /\((\S*)\).*?\[((.|\n)*)\]/, // pre 3.0 /\((\S*)\).*{((.|\n)*)}/,
  intervalSuffix: '_interval',
});

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    upgrades: upgradesEn,
    common: commonEn,
    statistics: statisticsEn,
    generators: generatorsEn,
    settings: settingsEn,
    menus: menusEn,
    tooltip: tooltipEn,
    infos: infosEn,
    game: gameEn,
    dungeon: dungeonEn,
  },
  fr: {
    upgrades: upgradesFr,
    common: commonFr,
    statistics: statisticsFr,
    generators: generatorsFr,
    settings: settingsFr,
    menus: menusFr,
    tooltip: tooltipFr,
    infos: infosFr,
    game: gameFr,
    dungeon: dungeonFr,
  },
  pt: {
    upgrades: upgradesPt,
    common: commonPt,
    statistics: statisticsPt,
    generators: generatorsPt,
    settings: settingsPt,
    menus: menusPt,
    tooltip: tooltipPt,
    infos: infosPt,
    game: gamePt,
    dungeon: dungeonPt,
  },
  de: {
    upgrades: upgradesDe,
    common: commonDe,
    statistics: statisticsDe,
    generators: generatorsDe,
    settings: settingsDe,
    menus: menusDe,
    tooltip: tooltipDe,
    infos: infosDe,
    game: gameDe,
    dungeon: dungeonDe,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(intervalPlural)
  .init({
    resources,
    lng: 'en', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
    debug: false, //import.meta.env.VITE_IS_PROD !== 'true',
    defaultNS: 'common',
    ns: ['common', 'statistics', 'generators', 'settings', 'purchase', 'menus', 'tooltip', 'infos', 'game', 'dungeon'],
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
